module.exports = "/assets/cf23d5b288ec4a8375cb8efc19f5672c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/W3.png
// module id = 3065
// module chunks = 0